import React from 'react';

const PoliciesTable = ({ policies }) => {
  return (
    <table className='table table-striped' aria-labelledby="tabelLabel">
      <thead>
        <tr>
          <th>Id</th>
          <th>GroupId</th>
          <th>CampaignId</th>
          <th>PolicyStatement</th>
          <th>EffectiveDate</th>
          <th>ActionStatus</th>
          <th>CreatedOn</th>
        </tr>
      </thead>
      <tbody>
        {policies.map(policy =>
          <tr key={policy.id}>
            <td>{policy.id}</td>
            <td>{policy.groupId}</td>
            <td>{policy.campaignId}</td>
            <td>{policy.policyStatement}</td>
            <td>{policy.effectiveDate}</td>
            <td>{policy.actionStatus}</td>
            <td>{policy.createdOn}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PoliciesTable;
